import { CENSORED_APPLICANT_STATUSES } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const CensoredApplicantsTableDefinitionZod = z.object({
    applicantId: schemaId,
    errors: z.array(z.string()),
    loanRequestId: schemaId,
    status: z.nativeEnum(CENSORED_APPLICANT_STATUSES),
    totalFailed: z.number().nullable(),
    totalModified: z.number().nullable(),
    totalSuccessful: z.number().nullable(),
});

export type CensoredApplicantsTableSchema = z.infer<typeof CensoredApplicantsTableDefinitionZod>;
